module.exports = __webpack_public_path__ + "static/bnr_wide@2x-6b867ec39560c791c7e809cb3651664a.png";